import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function PanCardservices() {
    
    return (
        <>
           <Header/>

            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <h1 className="text-white">Pan Card Services</h1>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-light rounded-pill"
                            >
                                SERVICES
                            </button>
                        </div>
                        <h1 style={{ textAlign: 'center' }}>
                            <span>Pan card</span> <span className="link-primary">Service</span>
                        </h1>
                    </div>
                </div>
            </section>
            <section id="about" className="about section light-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
                            <div className="about-content ps-0 ps-lg-3">
                                <p className="fst-italic">
                                    <b>Sai Financial Service</b> Provider is committed to making PAN card application and correction processes simple, efficient, and stress-free. Below are the details of the content, terms, and conditions for our PAN card services:

                                </p>
                                <h3>Services terms&conditions:</h3>
                                <ol style={{ listStyle: 'disc' }}>
                                    <li><p className="fst-italic"><b> New PAN Card Application:</b> Assistance in applying for a new Permanent Account Number (PAN) card for individuals, businesses, and organizations.</p></li>
                                    <li><p className="fst-italic"><b>PAN Card Corrections and Updates:</b> Support for correcting or updating details such as name, date of birth, or address on an existing PAN card.</p></li>
                                    <li><p className="fst-italic"><b>Service Fee Policy:</b> The ₹300 service fee is non-refundable, even in cases where the application is rejected due to incomplete or inaccurate information.</p></li>
                                    <li><p className="fst-italic"><b>Government Fees:</b>Any additional charges levied by the Income Tax Department or NSDL/UTIITSL for processing the PAN card application must be borne by the applicant.</p></li>
                                    <li><p className="fst-italic"><b>Accuracy of Information:</b> Applicants must provide accurate and complete details. Sai Financial Service Provider will not be responsible for delays or rejections caused by errors in the provided information.</p></li>
                                    <li><p className="fst-italic"><b>Documentation Responsibility:</b> The applicant is responsible for submitting all necessary documents in the prescribed format and within the required timeline.</p></li>
                                    
                                </ol>
                                <h3>Why Choose Us?</h3>
                                <ol style={{ listStyle: 'disc' }}>
                                    <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                                    <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                                    <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                                </ol>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
                            <img src="assets\images\svg\pancard-1.jpg" alt className="h-100 w-100 img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="container section-title" data-aos="fade-up">
                        <h1 style={{ textAlign: 'center' }}>
                            <span>Pan card</span> <span className="link-primary">Service</span>
                        </h1>
                    </div>
                </div>
            </section>
            <Servicedata/>
            <Footer />
        </>
    )
}

export default PanCardservices
